<mat-form-field appearance="fill" class="fuse-mat-dense fuse-mat-rounded w-44">
  <mat-select
    [value]="selectedId()"
    (selectionChange)="onSelectionChange($event)"
    [placeholder]="'select-workshop.placeholder' | transloco"
  >
    @for (workshop of workshops(); track workshop._id) {
      <mat-option [value]="workshop._id">
        {{ workshop.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
